// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:18
import { ResourcePositionHistory_abstract } from './../abstract/SagaSchema/ResourcePositionHistory_abstract';
export class ResourcePositionHistory extends ResourcePositionHistory_abstract {}
